

import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Project } from '../models/Project';
import { HomeElement } from '../models/HomepageElement';
import { Customer } from '../models/Customer';
import { WorkWithUs } from '../models/WorkWithUs';
import { User } from '../models/User';

@Injectable()
export class ApiService {

  constructor(private http: HttpClient) { }

  getProjects(translateActive: boolean = true) {
    return this.http.get<Array<Project>>(environment.apiURL + "/Get.php?table=progetti&translate=" + translateActive + "").toPromise();
  }
  getHomepageList(translateActive: boolean = true) {
    return this.http.get<Array<HomeElement>>(environment.apiURL + "/Get.php?table=home&translate=" + translateActive + "").toPromise();
  }
  getCustomers(translateActive: boolean = true) {
    return this.http.get<Array<Customer>>(environment.apiURL + "/Get.php?table=clienti&translate=" + translateActive + "").toPromise();
  }
  getWorkWithUs(translateActive: boolean = true) {
    return this.http.get<Array<WorkWithUs>>(environment.apiURL + "/Get.php?table=lavori&translate=" + translateActive + "").toPromise();
  }


  updateProject(id: number, project: Project[]) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(project));
    return this.http.post<Array<Project>>(environment.apiURL + "/PutProject.php?id=" + id, formData).toPromise();
  }
  updateHomepageList(id: number, homeElement: HomeElement[]) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(homeElement));
    return this.http.post<Array<HomeElement>>(environment.apiURL + "/PutHomeElement.php?id=" + id, formData).toPromise();
  }
  updateCustomers(id: number, customer: Customer[]) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(customer));
    return this.http.post<Array<Customer>>(environment.apiURL + "/PutCustomer.php?id=" + id, formData).toPromise();
  }
  updateWorkWithUs(id: number, workWithUs: WorkWithUs[]) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(workWithUs));
    return this.http.post<Array<WorkWithUs>>(environment.apiURL + "/PutWorkWithUs.php?id=" + id, formData).toPromise();
  }


  deleteProject(id: number) {
    return this.http.get<Array<Project>>(environment.apiURL + "/Delete.php?idObject=" + id + "&table=progetti").toPromise();
  }
  deleteHomepageList(id: number) {
    return this.http.get<Array<HomeElement>>(environment.apiURL + "/Delete.php?idObject=" + id + "&table=home").toPromise();
  }
  deleteCustomers(id: number) {
    return this.http.get<Array<Customer>>(environment.apiURL + "/Delete.php?idObject=" + id + "&table=clienti").toPromise();
  }
  deleteWorkWithUs(id: number) {
    return this.http.get<Array<WorkWithUs>>(environment.apiURL + "/Delete.php?idObject=" + id + "&table=lavori").toPromise();
  }

  createCustomers(newCustomer: Customer[]) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(newCustomer));
    return this.http.post<Array<Customer>>(environment.apiURL + "/Insert.php?table=clienti", formData).toPromise();
  }
  
  createProject(newProject: Project[]) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(newProject));
    return this.http.post<Array<Customer>>(environment.apiURL + "/Insert.php?table=progetti", formData).toPromise();
  }
  
  createHome(newHome: HomeElement[]) {
    throw new Error("Method not implemented.");
  }

  updateOrderingProject(ordering: number[]) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(ordering));
    return this.http.post<Array<Project>>(environment.apiURL + "/UpdateOrdering.php?table=progetti", formData).toPromise();
  }
  updateOrderingCustomers(ordering: number[]) {
    const formData = new FormData();
    formData.append('data', JSON.stringify(ordering));
    return this.http.post<Array<Customer>>(environment.apiURL + "/UpdateOrdering.php?table=clienti", formData).toPromise();
  }
  uploadImageCustomer(id: number, files) {
    const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
    const formData = new FormData();
    formData.append('data', JSON.stringify({ idObject: id, table: 'clienti' }));
    
    for (let file of files) {
      formData.append('file', file);
    }
    return this.http.post<Array<Customer>>(environment.apiURL + "/Upload.php", formData, { headers }).toPromise();
  }
  uploadImageProject(id: number, files) {
    const headers = new HttpHeaders().append('Content-Disposition', 'multipart/form-data');
    const formData = new FormData();
    formData.append('data', JSON.stringify({ idObject: id, table: 'progetti' }));

    for (let file of files) {
      formData.append('file', file);
    }
    return this.http.post<Array<Customer>>(environment.apiURL + "/Upload.php", formData, { headers }).toPromise();
  }

  login(user: User) {

    const formData = new FormData();
    formData.append('data', JSON.stringify(user));
    return this.http.post<User>(environment.apiURL + "/Login.php", formData).toPromise();
  }

}
